import React from 'react';
import { HiBell, HiXMark, HiCheck } from 'react-icons/hi2';

export const NotificationPermissionModal = ({ isOpen, onClose, onAllow }) => {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
            <div className="bg-white p-6 rounded-2xl max-w-sm w-full shadow-2xl transform transition-all scale-100">
                <div className="text-center mb-4">
                    <div className="bg-green-100 p-3 rounded-full inline-block mb-3">
                        <HiBell className="w-8 h-8 text-green-600" />
                    </div>
                    <h3 className="text-xl font-bold text-gray-800">Aktifkan Notifikasi?</h3>
                </div>
                <p className="mb-6 text-gray-600 text-center text-sm">
                    Dapatkan update status pesanan Anda secara realtime langsung di perangkat Anda.
                </p>
                <div className="flex flex-col gap-3">
                    <button
                        onClick={onAllow}
                        className="w-full py-3 bg-green-600 text-white rounded-xl font-semibold hover:bg-green-700 transition-colors flex items-center justify-center gap-2"
                    >
                        <HiCheck className="w-5 h-5" />
                        Izinkan Notifikasi
                    </button>
                    <button
                        onClick={onClose}
                        className="w-full py-3 text-gray-500 font-medium hover:text-gray-700 transition-colors"
                    >
                        Nanti Saja
                    </button>
                </div>
            </div>
        </div>
    );
};

export const NotificationBellIcon = ({ count, onClick }) => (
    <button onClick={onClick} className="relative p-2 rounded-full hover:bg-gray-100 transition-colors">
        <HiBell className="w-6 h-6 text-gray-700" />
        {count > 0 && (
            <span className="absolute top-1 right-1 bg-red-500 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center border-2 border-white">
                {count > 9 ? '9+' : count}
            </span>
        )}
    </button>
);

export const NotificationCenterModal = ({ isOpen, onClose, notifications, onClear }) => {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-end z-[60] transition-opacity">
            <div className="bg-white w-full max-w-md h-full shadow-2xl flex flex-col animate-slide-in-right">
                <div className="p-4 border-b flex justify-between items-center bg-white sticky top-0 z-10">
                    <h3 className="font-bold text-lg text-gray-800 flex items-center gap-2">
                        <HiBell className="w-5 h-5 text-green-600" />
                        Notifikasi
                    </h3>
                    <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
                        <HiXMark className="w-6 h-6 text-gray-500" />
                    </button>
                </div>

                <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-gray-50">
                    {notifications.length === 0 ? (
                        <div className="flex flex-col items-center justify-center h-64 text-gray-400">
                            <HiBell className="w-12 h-12 mb-2 opacity-20" />
                            <p>Belum ada notifikasi</p>
                        </div>
                    ) : (
                        notifications.map((n, i) => (
                            <div key={i} className={`p-4 bg-white rounded-xl shadow-sm border-l-4 ${n.read ? 'border-gray-300' : 'border-green-500'}`}>
                                <div className="flex justify-between items-start mb-1">
                                    <h4 className={`font-bold text-sm ${n.read ? 'text-gray-600' : 'text-gray-900'}`}>{n.title}</h4>
                                    <span className="text-[10px] text-gray-400 whitespace-nowrap ml-2">
                                        {n.timestamp ? new Date(n.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                                    </span>
                                </div>
                                <p className="text-sm text-gray-600 leading-relaxed">{n.body}</p>
                            </div>
                        ))
                    )}
                </div>

                {notifications.length > 0 && (
                    <div className="p-4 border-t bg-white">
                        <button
                            onClick={onClear}
                            className="w-full py-2 text-red-500 text-sm font-semibold hover:bg-red-50 rounded-lg transition-colors"
                        >
                            Hapus Semua Notifikasi
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}

export const InAppNotificationPopup = ({ notification, onClose }) => {
    if (!notification) return null;
    return (
        <div className="fixed top-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-white shadow-xl rounded-xl p-4 z-[70] animate-slide-in-top border border-gray-100 flex gap-3">
            <div className="flex-shrink-0 bg-green-100 p-2 rounded-full h-fit">
                <HiBell className="w-5 h-5 text-green-600" />
            </div>
            <div className="flex-1 min-w-0">
                <h4 className="font-bold text-gray-900 text-sm mb-1">{notification.title}</h4>
                <p className="text-sm text-gray-600 leading-snug">{notification.body}</p>
            </div>
            <button onClick={onClose} className="flex-shrink-0 text-gray-400 hover:text-gray-600 self-start">
                <HiXMark className="w-5 h-5" />
            </button>
        </div>
    )
}
